import { render, staticRenderFns } from "./LottoStats.vue?vue&type=template&id=6176f0c0&scoped=true&"
import script from "./LottoStats.vue?vue&type=script&lang=ts&"
export * from "./LottoStats.vue?vue&type=script&lang=ts&"
import style0 from "./LottoStats.vue?vue&type=style&index=0&id=6176f0c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6176f0c0",
  null
  
)

export default component.exports